import * as yup from 'yup';

export const updateCorporateProfileSignUpSchema = yup.object().shape({
    name: yup
        .string()
        .required('Company Name is required')
        .min(3, 'Company Name must be at least 3 characters long')
        .max(50, 'Company Name cannot exceed 50 characters'),


    address: yup
        .string()
        .required('Location is required'),

    phone_no: yup
        .string()
        .matches(/^\+?\d{7,15}$/, 'Phone Number must be valid and contain 7-15 digits')
        .required('Phone Number is required'),

    ein_number: yup
        .string()
        .required('Company EIN Number is required'),

    about: yup
        .string()
        .max(300, 'About Company cannot exceed 300 characters')
        .notRequired(),

    tax_id_number: yup
        .string()
        .required('Tax ID Number is required'),

    registration_number: yup
        .string()
        .required('Registration Number is required'),

    work_permit_id: yup
        .string()
        .required('Work Permit ID is required'),

    // profile: yup
    //     .mixed()
    //     .required('Company Logo is required')
    //     .test('fileSize', 'File size is too large', (value) => {
    //         return value && value.size <= 5 * 1024 * 1024; // Max 5MB
    //     })
    //     .test('fileType', 'Unsupported file format', (value) => {
    //         return value && ['image/jpeg', 'image/png', 'image/jpg'].includes(value.type);
    //     }),


    // // FOR REQUIRED
    // profile: yup
    //     .mixed()
    //     .test('fileRequired', 'Company Logo is required', function (value) {
    //         // Allow existing profile URL or validate a file object
    //         return typeof value === 'string' || (value && value.size <= 5 * 1024 * 1024);
    //     })
    //     .test('fileType', 'Unsupported file format', function (value) {
    //         if (typeof value === 'string') return true; // Skip type validation for existing URLs
    //         return value && ['image/jpeg', 'image/png', 'image/jpg'].includes(value.type);
    //     }),

    logo: yup
        .mixed()
        .notRequired() // Make optional
        .when('$isEditing', {
            is: true, // Only validate if editing
            then: yup
                .mixed()
                .required('Company Logo is required')
                .test('fileSize', 'File size is too large', (value) => value && value.size <= 5 * 1024 * 1024)
                .test('fileType', 'Unsupported file format', (value) => value && ['image/jpeg', 'image/png', 'image/jpg'].includes(value.type)),
        }),

});
